<template>
  <div class="dev-list">
    <div class="dev-list-search">
      <div class="search-btn">
        <el-button size="small" type="primary" @click="uploadFilePop()"
                   v-if="$store.getters.checkChangeAuth() || !$store.state.isAdmin">新增文件
        </el-button>
        <div @keyup.enter="getFileListForSearch">
          <el-input size="small" placeholder="输入文件名称 搜索" v-model="searchInfo.fileNameLike"
                    style="width: 320px">
            <el-button slot="append" icon="el-icon-search" @click="getFileListForSearch"></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="file-issue-list border-all">
      <el-table ref="multipleTable" size="mini" :height="tableHeight" :data="info.list" :max-height="tableHeight"
                :header-cell-style="{backgroundColor: '#efefef'}" tooltip-effect="dark" style="width: 99%"
                @row-click="checkRow">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="fileName" label="文件名"></el-table-column>
        <el-table-column prop="downPath" label="服务器保存相对路径"></el-table-column>
        <el-table-column prop="issuePath" label="设备分发路径"></el-table-column>
        <el-table-column prop="updateTime" label="上传时间"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" min-width="200px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.stop="issueFile(scope.row)">重新分发</el-button>
            <el-button type="text" size="small" @click.stop="goRecord(scope.row)">分发记录</el-button>
            <el-button type="text" size="small" @click.stop="editRemark(scope.row)">修改备注</el-button>
            <el-button type="text" size="small" @click.stop="delFile(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="list-bottom">
        <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="page.startPage"
                :page-sizes="[10, 20, 50]"
                :page-size="page.limit"
                :pager-count="5"
                layout="total, sizes, prev, pager, next"
                :total="info.total">
        </el-pagination>
      </div>

      <!-- 分发文件弹窗 -->
      <Drawer title="重新分发" :visible.sync="issueFileRPopShow" @handClick="issueFileR">
        <div>
          <el-form ref="form" :model="issueFileInfo" label-width="130px" label-position="left">
            <el-form-item size="mini" label="文件名">
              {{changeFile.fileName}}
            </el-form-item>
            <el-form-item size="mini" label="文件存放路径">
              {{changeFile.downPath}}
            </el-form-item>
            <el-form-item size="mini" label="设备分发路径">
              {{changeFile.issuePath}}
            </el-form-item>
            <el-form-item size="mini" label="上传时间">
              {{changeFile.updateTime}}
            </el-form-item>
            <el-form-item size="mini" label="选择分组">
              <div style="width:100%; height: 600px;">
                <el-scrollbar style="height:100%">
                  <el-tree
                          :props="props"
                          :load="loadNode"
                          lazy
                          show-checkbox
                          @check-change="handleCheckChange">
                  </el-tree>
                </el-scrollbar>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </Drawer>
    </div>

    <Drawer title="修改备注" :visible.sync="remarkPopShow" @handClick="changeRemark">
      <div>
        <el-form ref="remarkForm" :model="fileRemarkInfo" label-width="120px" label-position="left">
          <el-form-item size="mini" label="文件名：">
            {{fileRemarkInfo.fileName}}
          </el-form-item>

          <el-form-item size="mini" label="分发路径：">
            {{fileRemarkInfo.issuePath}}
          </el-form-item>
          <el-form-item size="mini" label="文件备注：">
            <el-input v-model="fileRemarkInfo.remark" style="width: 200px;" size="mini"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </Drawer>
    <!-- 上传文件 -->
    <Drawer title="新增文件" :visible.sync="uploadFilePopShow" @handClick="submitUpload" :before-close="popClose" :hasClick="clickOnce">
      <div>
        <el-form ref="form" :model="uploadFileExtraInfo" label-width="130px" label-position="left">
          <el-form-item size="mini" label="文件存放路径">
            <!--<el-input v-model.trim="uploadFileExtraInfo.issuePath"></el-input>-->
            <el-autocomplete
                    size="small"
                    style="width: 280px"
                    v-model="uploadFileExtraInfo.issuePath"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入路径"/>
          </el-form-item>
          <el-form-item size="mini" label="文件备注">
            <el-input v-model.trim="uploadFileExtraInfo.remark"></el-input>
          </el-form-item>
          <div class="mater-upload-container">
            <ChunkUpload
                    ref="upload"
                    :headers="$store.getters.getHeaders"
                    :chunk-size="chunkSize"
                    @upload_done="uploadFilesDone"
                    @upload_one="uploadOneFileDone"
                    @upload_fail="uploadOneFileFail"
            >
            </ChunkUpload>
          </div>
          <el-form-item size="mini" label="选择分组">
            <div style="text-align: left">
              <el-checkbox v-model="devAllSelect" @change="allSelectChangeHandle">全选</el-checkbox>
            </div>
            <div style="width:100%; height: 600px;">
              <el-scrollbar style="height:100%">
                <el-tree v-if="groupList.length"
                         ref="tree"
                         :props="props"
                         :load="loadNode"
                         node-key="name"
                         lazy
                         show-checkbox
                         @check-change="handleCheckChange">
                </el-tree>
              </el-scrollbar>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </Drawer>
  </div>
</template>

<script>
    import Drawer from '@/components/Drawer'
    import ChunkUpload from '@/components/ChunkUpload.vue'

    export default {
        name: "FileList",
        components: {
            Drawer, ChunkUpload
        },
        data() {
            return {
                clickOnce:false,
                chunkSize: 10 * 1024 * 1024,
                share: 1,
                devAllSelect: false,
                tableHeight: 0,
                props: {
                    label: 'name',
                    children: 'children',
                    isLeaf: 'leaf'
                },
                groupSelectList: [],
                groupList: [],
                lowSpaceDeviceList:[],
                addFileList: [],
                info: {
                    success: false,
                    list: [],
                    total: 0
                },
                page: { // 分页参数
                    startPage: 1,
                    limit: 10
                },
                fileList: [],
                issueFileInfo: {
                    issuePath: '',
                    deviceIps: '',
                    id: 1,
                },
                fileRemarkInfo: {},
                issueFileRPopShow: false, // 显示修改分组名称弹窗
                uploadFilePopShow: false,
                remarkPopShow: false,
                uploadFileExtraInfoDefault: {
                    issuePath: '',
                    deviceIps: '',
                    remark:''
                },
                uploadFileExtraInfo: {
                    issuePath: '',
                    deviceIps: '',
                    remark:''
                },
                searchInfo: {
                    fileNameLike: ""
                },
                uploadPopCloseTip: false,
                changeFile: {}
            }
        },
        computed: {},
        methods: {
            querySearch (queryString, cb) {
                var issuePathHistory = this.getIssuePathHistory()
                var results = queryString ? issuePathHistory.filter(this.createFilter(queryString)) : issuePathHistory
                cb(results)
            },
            createFilter (queryString) {
                return (issuePath) => {
                    return (issuePath.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
                }
            },
            handleSearchHistory () {
                let issuePathArray = localStorage.getItem('issuePath')
                if (issuePathArray) {
                    issuePathArray = issuePathArray.split(',')
                } else {
                    issuePathArray = []
                }
                if (issuePathArray.indexOf(this.uploadFileExtraInfo.issuePath) === -1) {
                    issuePathArray.unshift(this.uploadFileExtraInfo.issuePath)
                }
                if (issuePathArray.length > 20) {
                    issuePathArray.pop()
                }
                localStorage.setItem('issuePath', issuePathArray)
            },
            getIssuePathHistory () {
                let issuePathArray = localStorage.getItem('issuePath')
                if (issuePathArray) {
                    issuePathArray = issuePathArray.split(',')
                }
                let issuePathHistory = []
                for (let i=0; issuePathArray && i < issuePathArray.length; i++) {
                    let item = {
                        "value": issuePathArray[i],
                        "label": issuePathArray[i]
                    }
                    issuePathHistory.push(item)
                }
                // console.log("issuePathHistory ", issuePathHistory)
                return issuePathHistory
            },
            uploadOneFileDone(file) {
                console.log("uploadOneFileDone file " + JSON.stringify(file))
                let that = this
                const body = {
                    fileName: file.fileName,
                    uuid: file.fileHash,
                    ...that.uploadFileExtraInfo
                }
                // console.log("body is " + JSON.stringify(body))
                that.$post(that.$uri.file.saveAddChunk, {...body}).then(res => {
                    // console.log("saveAddChunk res " + JSON.stringify(res))
                    if (res.success) {
                        that.$message.success("上传成功---" + file.fileName)
                        // that.$refs.upload.clearOneFile(file.fileHash)
                    } else {
                        that.$message.error("上传失败---" + file.fileName)
                    }
                })
            },
            uploadFilesDone(file) {
                console.log("uploadFilesDone file " + JSON.stringify(file))
                let that = this
                // console.log("filaName " + file.fileName + " hash: " + file.fileHash)
                const body = {
                    fileName: file.fileName,
                    uuid: file.fileHash,
                    ...that.uploadFileExtraInfo
                }
                // console.log("body is " + JSON.stringify(body))
                that.$post(that.$uri.file.saveAddChunk, {...body}).then(res => {
                    // console.log("saveAddChunk res " + JSON.stringify(res))
                    if (res.success) {
                        that.$message.success("上传完成---" + file.fileName)
                        that.$refs.upload.clearFiles()
                        that.uploadFilePopShow = false
                        that.uploadPopCloseTip = false
                        that.clickOnce = false
                        that.getFileList()
                    }
                }).catch(()=>{
                    that.$message.error("上传失败---" + file.fileName)
                    that.$refs.upload.clearFiles()
                    that.uploadFilePopShow = false
                    that.uploadPopCloseTip = false
                    that.clickOnce = false
                    that.getFileList()
                })
            },
            uploadOneFileFail(errMsg) {
                // console.log("upload fail: " + errMsg)
                this.$message.error("上传失败：" + errMsg)
                this.$refs.upload.clearFiles()
                this.uploadFilePopShow = false
                this.uploadPopCloseTip = false
                this.clickOnce = false
                this.getFileList()
            },
            allSelectChangeHandle(n) {
                this.devAllSelect = n
                let tree = this.$refs.tree
                if (n) {
                    tree.setCheckedKeys(this.groupList.map(g => g.name))
                } else {
                    tree.setCheckedNodes([])
                }
            },
            handleCheckChange(data, checked, indeterminate) {
                data.checked = checked
                let s = []
                let allCheck = true
                this.groupList.forEach(g => {
                    g.children.forEach(c => {
                        if (g.checked || c.checked) {
                            s.push(c.deviceIp)
                        } else {
                            allCheck = false
                        }
                    })
                })
                this.devAllSelect = allCheck
                this.uploadFileExtraInfo.deviceIps = s.join(",")
            },
            filterRemark(ip, remark) {
                if (remark.length > 0) {
                    return "（" + ip + "/" + remark + "）"
                } else {
                    return "（" + ip + "）"
                }
            },
            sortDev(list) {
                list.sort((d1, d2) => {
                    return d1.id >= d2.id ? 1 : -1;
                });
            },
            loadNode(node, resolve) {
                let that = this
                if (node.level === 0) {
                    this.groupList.forEach(g => {
                        if (!g.children) {
                            g.name = g.groupName
                            g.checked = false
                            that.$post(that.$uri.device.deviceList, {groupId: g.id}).then(res => {
                                if (res.success) {
                                    let list = res.list
                                    // console.log("deviceList is ", list)
                                    list.forEach(d => {
                                        // console.log("d is " + JSON.stringify(d))
                                        d.name = d.id + that.filterRemark(d.deviceIp, d.remark)
                                        d.checked = false
                                        d.leaf = true
                                        if (d.disk < 10) {
                                            that.lowSpaceDeviceList.push(d.deviceIp)
                                        }
                                    })
                                    this.sortDev(list)
                                    g.children = list
                                }
                            })
                        }
                    })
                    return resolve(this.groupList);
                }
                if (node.level = 1) return resolve(node.data.children);
                if (node.level > 1) return resolve([]);
            },
            delFile(row) {
                let that = this
                that.$post(that.$uri.file.fileDel, {ids: row.id}).then(res => {
                    if (res.success) {
                        that.$message.success("删除成功")
                        that.getFileList()
                    }
                })
            },
            issueFile(row) {
                this.$store.commit(this.$mutation.FILE_ISSUE_INFO, row)
                this.$router.push('/home/file/issue')
            },
            goRecord(row) {
                this.$store.commit(this.$mutation.FILE_ISSUE_INFO, row)
                this.$router.push('/home/file/record')
            },
            editRemark(row) {
                this.fileRemarkInfo = JSON.parse(JSON.stringify(row))
                this.remarkPopShow = true
            },
            issueFileR() {
                let that = this
                that.$post(that.$uri.file.fileIssue, {
                    ids: that.changeFile.id,
                    deviceIps: that.uploadFileExtraInfo.deviceIps
                }).then(res => {
                    if (res.success) {
                        that.$message.success("分发成功")
                        that.issueFileRPopShow = false
                    }
                })
            },
            /* 表单击行事件 */
            checkRow(r, c, e) {
                this.$store.commit(this.$mutation.FILE_ISSUE_INFO, r)
                this.$router.push('/home/file/issue')
            },

            /* 获取文件列表 */
            getFileList() {
                this.$post(this.$uri.file.fileList, {
                    ...this.page,
                    fileNameLike: this.searchInfo.fileNameLike
                }).then(res => {
                    // console.log("getFileList ", JSON.stringify(res))
                    this.info = res
                    this.info.list.forEach(f => {
                        f.updateTime = this.$util.formatDate(new Date(f.updateTime))
                    })
                    this.$nextTick().then(() => {
                        this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                    })
                })
            },
            getFileListForSearch() {
                this.page.startPage = 1
                this.$post(this.$uri.file.fileList, {
                    ...this.page,
                    fileNameLike: this.searchInfo.fileNameLike
                }).then(res => {
                    // console.log("getFileList ", JSON.stringify(res))
                    this.info = res
                    this.info.list.forEach(f => {
                        f.updateTime = this.$util.formatDate(new Date(f.updateTime))
                    })
                    this.$nextTick().then(() => {
                        this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                    })
                })
            },
            getMyGroupList() {
                let that = this
                that.$post(that.$uri.group.list, {}).then(res => {
                    if (res.success) {
                        that.groupList = res.list
                    }
                })
            },
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getFileList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getFileList()
            },

            /* 上传文件弹窗 */
            uploadFilePop() {
                this.uploadFileExtraInfo = JSON.parse(JSON.stringify(this.uploadFileExtraInfoDefault))
                this.groupSelectList = []
                this.addFileList = []
                this.uploadFilePopShow = true
                this.$nextTick().then(() => {
                    if (this.$refs.tree) {
                        this.allSelectChangeHandle(false)
                    }
                })
            },
            popClose() {
                if (this.uploadPopCloseTip) {
                    this.$confirm("文件正在上传中，确定关闭弹窗？", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {
                        // this.$refs.upload.clearFiles()
                        this.uploadFilePopShow = false
                    }).catch(() => {
                    })
                } else {
                    this.uploadFilePopShow = false
                    this.uploadFileExtraInfo = {
                        issuePath: '',
                        deviceIps: '',
                    }

                    this.$refs.upload.clearFiles()
                }
            },
            changeRemark() {
                let that = this
                that.$post(that.$uri.file.fileEdit, {
                    id:that.fileRemarkInfo.id,
                    remark: that.fileRemarkInfo.remark
                }).then(res => {
                    if (res.success) {
                        that.$message.success("修改成功")
                        that.getFileList()
                        that.remarkPopShow = false
                    }
                })
            },
            /* 上传文件 */
            submitUpload() {
                this.issueFileInfo.deviceIps = this.uploadFileExtraInfo.deviceIps
                // console.log("this.uploadFileExtraInfo " + JSON.stringify(this.uploadFileExtraInfo))
                // console.log("groupSelectList " + JSON.stringify(this.groupSelectList))
                if (this.issueFileInfo.deviceIps.length === 0) {
                    this.$confirm("请勾选需要分发上传文件的设备", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        showCancelButton: false
                    }).then(() => {

                    }).catch(() => {
                    })
                } else {
                    let lowSpaceList = []
                    let selectIps = this.issueFileInfo.deviceIps.split(",")
                    selectIps.forEach(item=>{
                        if (this.lowSpaceDeviceList.indexOf(item) !== -1) {
                            lowSpaceList.push(item)
                        }
                    })
                    if (lowSpaceList.length > 0) {
                        let msg = "云机(" + lowSpaceList.join("、") + ")存储空间不足10%，继续分发文件可能导致云机故障造成数据损坏，请清理云机空间后重新进行分发。"
                        this.$confirm(msg, "云机空间不足提醒", {
                            confirmButtonText: '继续分发',
                            confirmButtonClass: 'confirm-btn-red',
                            iconClass: 'el-icon-c-red',
                            showCancelButton: true,
                            cancelButtonText:'取消分发',
                            cancelButtonClass:'confirm-btn-blue'
                        }).then(() => {
                            this.uploadPopCloseTip = true
                            this.clickOnce = true
                            this.handleSearchHistory()
                            this.$refs.upload.handleUpload()
                        }).catch(() => {
                        })
                    } else {
                        this.uploadPopCloseTip = true
                        this.clickOnce = true
                        this.handleSearchHistory()
                        this.$refs.upload.handleUpload()
                    }
                }
            },
            // handleSuccess(response, file, fileList) {
            //     if (response.success) {
            //         let allDone = true
            //         fileList.forEach(item => {
            //             if (item.percentage != 100) {
            //                 allDone = false
            //             }
            //         })
            //         if (allDone) {
            //             this.uploadFilePopShow = false
            //             this.uploadPopCloseTip = false
            //             this.$refs.upload.clearFiles()
            //             this.$message.success("上传成功")
            //             // console.log("data is " + JSON.stringify(response.data))
            //             this.getFileList()
            //         }
            //     } else {
            //         this.$message.error(response.message)
            //         this.$refs.upload.clearFiles()
            //     }
            // },
            handleUpload() {
                this.uploadPopCloseTip = true
            },
            handleRemove(file, fileList) {
            },
            handlePreview(file) {
            },
            handleProgress(event, file, fileList) {
                if (!this.uploadFilePopShow) {
                    this.$refs.upload.abort(file)
                    this.$refs.upload.clearFiles()
                }
            },

            /* 管理 */
            manage(info) {
                this.$store.commit(this.$mutation.GROUP_DETAIL, info)
                this.$router.push("/home/group/dev/manage")
            },
            /* 跳转组内设备 */
            goGroupDev(info) {
                this.$store.commit(this.$mutation.GROUP_DETAIL, info)
                this.$router.push("/home/group/dev")
            },
            /* 跳转应用管理 */
            goAppManage(info) {
                this.$store.commit(this.$mutation.GROUP_DETAIL, info)
                this.$router.push("/home/group/app/manage")
            }
        },
        filters: {},
        mounted() {
            this.getFileList()
            this.getMyGroupList()
        }
    };
</script>
<style lang="less" scoped>
  .popup-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .dev-list {
    .dev-list-search {
      width: 100%;
      display: flex;
      flex-direction: column;
      .search-btn {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .search-advanced {
        display: flex;
        flex-direction: column;
        .search-main {
          margin-top: 10px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: wrap;
          .search-main-item {
            width: 24%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            /*flex-grow: 1;*/
            padding: 5px 10px;
            span {
              font-size: 12px;
            }
            .item-input {
              width: 180px;
            }
          }
        }
        .search-btn {
          padding: 0 10px;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
    .file-issue-list {
      margin-top: 10px;
      .list-bottom {
        padding: 10px 8px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .list-bottom-btn {
          display: flex;
          flex-direction: row;
        }
      }
    }
  }

  .el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-tree > .el-tree-node {
    min-width: 100%;
    display: inline-block;
  }

  .mater-upload-container {
    border: none;
    max-height: 500px;
    margin-bottom: 30px;
  }
</style>